import { render, staticRenderFns } from "./Wjtz.vue?vue&type=template&id=926337c4&scoped=true"
import script from "./Wjtz.vue?vue&type=script&lang=js"
export * from "./Wjtz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926337c4",
  null
  
)

export default component.exports